<template>
  <base-card :projectID="projectID" :categoryID="categoryID" :storyType="storyType" :isMarginless="isMarginless" :isRowLoading="isRowLoading" :isPinnableRow="isPinnableRow" :pinnedProjects="pinnedProjects" :disableLink="disableLink">
    <information :isRowLoading="isRowLoading" :isBlank="isBlank">
      <resource-type :project="project"></resource-type>
    </information>
    <project-title :isRowLoading="isRowLoading" :isBlank="isBlank" :title="title" :elementID="elementID" :customLineClamp="3"/>
    <project-image :image="image" :isRowLoading="isRowLoading" :imageBackground="imageBackground" :isBlank="isBlank" :isVisible="isVisible" :imageOverlay="imageOverlay"/>
    <information v-if="this.isDisabled" class="lower" :isRowLoading="isRowLoading" :isBlank="isBlank">
      <span class="lower-container">
        <!-- <user :members="[project.user]"/> -->
        <div class="date-container">
          <i class="far fa-calendar-alt"></i>
          <h4>{{formatDate(this.project.resource.webinar.webinar_date)}}</h4>
        </div>
      </span>
    </information>
  </base-card>
</template>

<script>
import BaseCard from './BaseCard'
import base from '../mixins/base'
import visibility from '@/mixins/visibility'
import ProjectTitle from '../UI/Title'
import Information from '../UI/Information'
import ProjectImage from '../UI/ProjectImage'
import ResourceType from '../UI/ResourceType'
import moment from 'moment'
import User from '../UI/User'
export default {
  name: 'Webinar',
  components: {
    BaseCard,
    ProjectTitle,
    Information,
    ProjectImage,
    User,
    ResourceType
  },
  props: {
    projectID: Number,
    categoryID: Number,
    storyType: Boolean,
    isMarginless: [Boolean, String],
    isRowLoading: Boolean,
    isPinnableRow: Boolean,
    pinnedProjects: Array,
    disableLink: Boolean
  },
  mixins: [base, visibility],
  computed: {
    isDisabled: function () {
      return false
    }
  },
  methods: {
    formatDate: function (date) {
      return moment(date).format('YYYY-MM-DD')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .lower-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin: 0 0.5rem;
    @include mobile {
      margin: 0;
    }
    h4 {
      font-family: $primary-font;
      font-size: 0.75rem;
      font-weight: 400;
      padding-left: 0.25rem;
      color: var(--background-third);
      @include mobile {
        font-size: 0.65rem;
      }
    }
    i {
      padding-left: 0.25rem;
      color: var(--background-third);
    }
    .date-container {
      display: flex;
      padding-right: 0.25rem;
      min-height: 35px;
      align-items: center;
    }
    ::v-deep .avatar-container {
      height: 1.25rem;
      width: 1.25rem;
      margin-right: 0.10rem;
    }

    ::v-deep .name-container {
      max-width: 70px;
      @include mobile {
        max-width: 40px;
      }
    }
    ::v-deep .users-main-container {
      padding-left: 0;
      width: auto;
    }
  }
  ::v-deep .main-container .story-title {
    min-height: 69.95px;
    margin-top: 0;
    @include mobile {
    min-height: 62.95px;
    }
  }
</style>
